import { ReactElement } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface TabProps {
  children: ReactElement
}

const Tab = ({ children }: TabProps) => <Box paddingTop="s24">{children}</Box>

export default Tab
